import { useState } from "react";
import { createContext } from "react";

export const BreadcrumbItemContext = createContext({});

export const BreadcrumbItemContextProvider = (props) => {
  const [breadcrumbItem, setBreadcrumbItem] = useState(null);

  return (
    <BreadcrumbItemContext.Provider value={{breadcrumbItem, setBreadcrumbItem}}>
      {props.children}
    </BreadcrumbItemContext.Provider>
  );
};